/**
 * User entity schema
 */

import { z } from 'zod';

export const UserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  display_name: z.string().nullable(),
  handle: z.string().nullable().optional(),
  avatar_url: z.string().nullable().optional(),
  bio: z.string().nullable().optional(),
  timezone: z.string().nullable().optional(),
  preferences: z.record(z.string(), z.unknown()).nullable().optional(),
  is_admin: z.union([z.literal(0), z.literal(1), z.boolean()]),
  credit_balance_micros: z.number().default(0),
  email_verified: z.union([z.literal(0), z.literal(1), z.boolean()]).optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type User = z.infer<typeof UserSchema>;
